import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-ui-page',
    templateUrl: './ui-page.component.html',
    styleUrls: ['./ui-page.component.scss'],
    standalone: false
})
export class UiPageComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
